var r=10;export{r as AXIS_FONT_SIZE};
